import { camelCase } from 'lodash'

import { ORDER_TYPE_OPTIONS } from '@/api/orders'

const stringUtils = {
  methods: {
    capitalize(string) {
      return !string || typeof string !== 'string' ? string : string.charAt(0).toUpperCase() + string.slice(1)
    },
    capitalizeCamelCase(string) {
      return !string || typeof string !== 'string'
        ? string
        : string.charAt(0).toUpperCase() + camelCase(string.slice(1))
    },
    decimal(numberString, options = { showPlusSign: false }) {
      const formatter = new Intl.NumberFormat(this.$i18n.locale, {
        style: 'decimal',
        signDisplay: options.showPlusSign ? 'always' : 'auto',
        maximumFractionDigits: 2,
      })

      return formatter.format(numberString)
    },
    percentage(numberString, options = { showPlusSign: false }) {
      const formatter = new Intl.NumberFormat(this.$i18n.locale, {
        style: 'percent',
        signDisplay: options.showPlusSign ? 'always' : 'auto',
        maximumFractionDigits: 2,
      })

      return formatter.format(numberString)
    },
    euro(numberString, options = { showPlusSign: false }) {
      const formatter = new Intl.NumberFormat(this.$i18n.locale, {
        style: 'currency',
        currency: 'EUR',
        signDisplay: options.showPlusSign ? 'always' : 'auto',
        maximumFractionDigits: 2,
      })

      return formatter.format(numberString)
    },
    toKebabCase(string) {
      return !string || typeof string !== 'string' ? string : string.toLowerCase().replace(/ /g, '-')
    },
    labelForOrderType(value) {
      const orderType = ORDER_TYPE_OPTIONS.find(element => element.value == value)
      if (orderType) {
        return orderType.label_i18n
      } else {
        return value
      }
    },
    parseNumberString(numberString) {
      const sanitized = numberString
        .replace(/[^\d.,-]/g, '') //  remove all non-numeric chars except dot, comma, and negative sign
        .replace(/,/g, '.') // replace comma with dot
        .replace(/[.](?=.*[.])/g, '') // remove all but last dot

      // convert to number
      return parseFloat(sanitized)
    },
    compareLocaleString(a, b, sortOrder) {
      if (!b) return -1
      if (!a) return 1
      if (sortOrder === 'descending') {
        return b.localeCompare(a, this.$i18n.locale, { sensitivity: 'base' })
      }
      return a.localeCompare(b, this.$i18n.locale, { sensitivity: 'base' })
    },
  },
}

export default stringUtils
